<template>
    <div class="ppv2-p-6">
        <PrestationTagForm v-if="!isLoading" :editItem="editItem" @success="handleSuccess" @cancel="handleCancel" />
        <div v-else class="ppv2-flex ppv2-justify-center ppv2-py-10">
            <span class="ppv2-text-gray-500">{{ $t('tag.loading') }}</span>
        </div>
    </div>
</template>

<script>
import PrestationTagForm from './PrestationTagForm.vue'
import axios from 'axios'

export default {
    name: 'BoExperienceV3TagForm',
    components: {
        PrestationTagForm,
    },
    props: {
        tagId: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            editItem: null,
        }
    },
    async created() {
        if (this.tagId) {
            this.isLoading = true
            try {
                const response = await axios.get(`/back-office/v3/tag/show/${this.tagId}`)
                if (response.data.success) {
                    this.editItem = response.data.data
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.isLoading = false
            }
        }
    },
    methods: {
        handleSuccess() {
            // Redirect back to the experience list
            window.location.href = '/back-office/v3/experience?tab=tags'
        },
        handleCancel() {
            window.location.href = '/back-office/v3/experience?tab=tags'
        },
    },
}
</script>
